/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".list-group-subgroup-button[_ngcontent-%COMP%]{text-align:left;width:100%}.list-group-subgroup-button[_ngcontent-%COMP%]:disabled{color:#ccc;cursor:default!important}.list-group-item.border-warning[_ngcontent-%COMP%]{color:#000}.disabled[_ngcontent-%COMP%]{color:#ccc}.disabled[_ngcontent-%COMP%]   .location-group-rule-icon[_ngcontent-%COMP%]{opacity:.5}.pointer-none[_ngcontent-%COMP%]{pointer-events:none}"];
export { styles as styles };
